import dayjs from "dayjs"
import { WalletMinus } from "iconsax-reactjs"

import { Image } from "@/components/ui"
import type { Transaction } from "@/modules/types"

type TransactionItemProps = {
  item: Transaction
}

import { ETransactionStatus } from "@/features/earns/components/progress-jobs/transaction.constants"

export function TransactionItem({ item }: TransactionItemProps) {
  const isCompleted = item.status === ETransactionStatus.COMPLETED
  const isRejected = item.status === ETransactionStatus.REJECTED

  return (
    <div className="bg-white border-b border-gray-200 pb-2 pt-2">
      <div className="flex items-start justify-between gap-4">
        {/* Left Section */}
        <div className="flex items-start gap-3 flex-1">
          {/* Icon */}
          <div className="flex-shrink-0 mt-1">
            <WalletMinus size={24} color="#0091AA" variant="Outline" />
          </div>

          {/* Transaction Details */}
          <div className="flex flex-col flex-1">
            {/* Transaction ID */}
            <p className="text-sm font-bold text-gray-900">#{item.id}</p>

            {/* Request Date */}
            <p className="text-xs font-normal text-gray-500">
              Ngày yêu cầu: {dayjs(item?.createdAt).format("DD/MM/YYYY")}
            </p>

            {/* Bank Account */}
            <div className="flex items-center gap-2 mt-1">
              <p className="text-xs font-normal text-gray-500">Tài khoản nhận:</p>
              {item?.bankAccount?.banks?.thumbnail && (
                <Image
                  src={item.bankAccount.banks.thumbnail}
                  alt={item.bankAccount.banks.bankName || ""}
                  className="w-5 h-5 object-contain rounded-full"
                />
              )}
              <p className="text-sm font-semibold text-gray-900">
                •••• {item?.bankAccount?.accountNumber?.slice(-4)}
              </p>
              <p className="text-sm font-semibold text-gray-900"></p>
            </div>
            {isRejected && (
              <p className="text-sm font-normal text-gray-500 mt-0.5">
                Số tiền đã hoàn:{" "}
                <span className="font-semibold text-gradient-primary">
                  {Number(item?.amount)?.toLocaleString()} ₫
                </span>
              </p>
            )}
          </div>
        </div>

        {/* Right Section */}
        <div className="flex flex-col items-end gap-1  flex-shrink-0">
          {/* Status Badge */}
          <span
            className={`inline-flex items-center px-3 py-1 text-xss font-normal rounded-lg 
              ${
                isCompleted
                  ? "bg-teal-50 text-teal-700"
                  : isRejected
                    ? "bg-red-50 text-red-700"
                    : "bg-orange-100 text-orange-700"
              }`}
          >
            {isCompleted ? "Rút thành công" : isRejected ? "Đã từ chối" : "Chờ thanh toán"}
          </span>
          {/* Amount */}
          <p
            className={`text-base font-bold whitespace-nowrap ${
              isCompleted
                ? "text-black"
                : isRejected
                  ? "text-gradient-primary"
                  : "text-gradient-primary"
            }`}
          >
            {isCompleted && "-"}
            {Number(item?.amount)?.toLocaleString()} ₫
          </p>{" "}
        </div>
      </div>
    </div>
  )
}
